import { useRef } from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import Logger from '../../../../../utils/logger';
import { FUNNEL_NAME } from '../../../../../server/handlers/personalization/constants';
import { maxios } from '../../../../../utils/maxios';

/**
 * given gig id and section name, this method fetches the personalized data of the desired section
 * data includes gigs recommended to user
 *
 * @param gigId
 * @param sectionName
 * @returns {Promise<{}|*>}
 */
const fetchPersonalizedData = async ({ gigId, sectionName }) => {
    const url = pathfinder('personalization', {
        section_name: sectionName,
    });

    const requestPayload = {
        app_name: 'gig_page',
        perseus_name: 'gig_page',
        pageName: FUNNEL_NAME,
        funnelName: FUNNEL_NAME,
        gig: { id: gigId },
    };

    try {
        const { data = {} } = await maxios.post(url, requestPayload, { routeKey: 'fetch_personalization_data' });
        const [section = {}] = data.sections?.[sectionName] ?? [];

        return section;
    } catch (error) {
        const logger = Logger.getInstance();

        logger.error(error, {
            description: 'Failed to fetch post fmp more gigs',
        });

        return {};
    }
};

/**
 * this hook builds a callback used to fetch data for the offer more gigs step in the send message package.
 * the response from this callback is stored locally to be reused if called again.
 *
 * @param gigId
 * @returns {((function(sectionName: string): Promise<*|{}>)|*)}
 */
export const usePostFmpFetchMoreGigsData = ({ gigId }) => {
    const data = useRef({});

    return async (sectionName) => {
        if (data.current[sectionName]) {
            return data.current[sectionName];
        }

        const sectionData = await fetchPersonalizedData({ gigId, sectionName });
        data.current[sectionName] = sectionData;

        return sectionData;
    };
};
